"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ruleStyles = void 0;

var _styledComponents = require("styled-components");

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var ruleStyles = (0, _styledComponents.css)(["color:", ";font-weight:normal;"], _tokens["default"].textColor.subtle);
exports.ruleStyles = ruleStyles;

var labelStyles = function labelStyles(_ref) {
  var isVisuallyHidden = _ref.isVisuallyHidden;
  return (0, _styledComponents.css)(["color:", ";display:inline-block;font-size:inherit;font-weight:bold;margin:0 ", " ", " 0;padding:0;position:relative;", " ", ""], _tokens["default"].textColor["default"], _stylers["default"].spacer(4), _tokens["default"].spaceSm, _stylers["default"].lineHeight(-1), isVisuallyHidden && _stylers["default"].visuallyHidden);
};

var _default = labelStyles;
exports["default"] = _default;
//# sourceMappingURL=Label.styles.js.map